import './LabelSwitch.scss';
import { prefixClass } from 'lib/utils';
import LabelSwitchItem from './LabelSwitchItem';
import { useEffect, useState } from 'react';
import { AskRequestStatus } from '@hone-automation/common';

export type SwitchProps = {
  label: string;
  value: string;
  tooltip?: string;
};

type LabelSwitchProps = {
  labels: SwitchProps[];
  selected: string;
  onSelect: (value: string) => void;
  pulseField?: string;
  pulseInProgress?: boolean;
  type?: AskRequestStatus | 'Blocker';
};

const LabelSwitch = (props: LabelSwitchProps) => {
  const { labels, selected, onSelect, pulseField, pulseInProgress, type } = props;
  const prefix = prefixClass('label-switch');
  const [selectedState, setSelectedState] = useState(selected);

  const handleSelect = (value: string) => {
    setSelectedState(value);
    onSelect(value);
  };

  useEffect(() => {
    setSelectedState(selected);
  }, [selected]);

  return (
    <div className={prefix()}>
      {labels.map((label, index) => (
        <LabelSwitchItem
          key={index}
          label={label.label}
          tooltip={label.tooltip}
          selected={label.value === selectedState}
          onClick={() => handleSelect(label.value)}
          pulse={pulseInProgress && label.value === pulseField}
          badge={pulseInProgress && label.value === pulseField ? '+1' : undefined}
          type={type}
        />
      ))}
    </div>
  );
};

export default LabelSwitch;
